"use client"

import { cn } from "@rarible_int/anaconda_ui_components"
import { useCallback, useState } from "react"

const COLORS = ["#FF2C86", "#8D4ED1", "#0052FF", "#6CD42B", "#EEFF00"]
const LETTERS = [LetterR, LetterA, LetterR, LetterI, LetterB, LetterL, LetterE]

export function Rarible({ className }: { className?: string }) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null)
  const [hoveredColor, setHoveredColor] = useState<string | null>(null)

  const handleLetterHover = useCallback(
    (index: number) => {
      const availableColors = hoveredColor
        ? COLORS.filter((color) => color !== hoveredColor)
        : COLORS

      const newColor =
        availableColors[Math.floor(Math.random() * availableColors.length)]

      setHoveredIndex(index)
      setHoveredColor(newColor)
    },
    [hoveredColor],
  )

  const handleLetterLeave = useCallback(() => setHoveredIndex(null), [])

  return (
    <div
      className={cn(
        "flex aspect-[1380/185] items-center justify-center gap-[0.87%]",
        className,
      )}
    >
      {LETTERS.map((Letter, index) => (
        <Letter
          key={index}
          onMouseEnter={() => handleLetterHover(index)}
          onMouseLeave={handleLetterLeave}
          className="h-full w-auto cursor-pointer"
          style={{
            color:
              hoveredIndex === index && hoveredColor ? hoveredColor : "white",
          }}
        />
      ))}
    </div>
  )
}

function LetterR(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="223"
      height="185"
      viewBox="0 0 223 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V185H56.0922V121.734H137.081L166.177 185H222.569L188.974 113.639L214.17 88.4522V33.282L180.575 0H0ZM149.079 79.1572H56.0922V42.577H149.079L159.578 53.0713V68.6629L149.079 79.1572Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function LetterA(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="222"
      height="185"
      viewBox="0 0 222 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.569092 185L65.3601 0H156.547L221.338 185H167.946L150.848 140.924H71.0593L53.9617 185H0.569092ZM85.1573 97.7472H136.75L116.353 42.2771H105.554L85.1573 97.7472Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function LetterI(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="55"
      height="185"
      viewBox="0 0 55 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M1.50739 185V166.71L0.907471 30.2836V0H54.9V30.2836H54.6001L54.0001 166.71V185H1.50739Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function LetterB(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="221"
      height="185"
      viewBox="0 0 221 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.899902 0V185H187.174L220.469 151.718V111.84L196.773 89.6515L211.771 74.3598V33.282L178.475 0H0.899902ZM147.579 73.7601H56.9921V42.577H147.579L158.078 53.0713V63.2658L147.579 73.7601ZM153.879 142.423H56.9921V112.739H153.879L164.377 123.233V131.929L153.879 142.423Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function LetterL(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="158"
      height="185"
      viewBox="0 0 158 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M0.469482 185V0H56.5618V139.425H157.948V185H0.469482Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function LetterE(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Svg title does not make sense here
    <svg
      width="199"
      height="185"
      viewBox="0 0 199 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M0.94751 185V0H198.92V45.5754H57.0397V71.3614H187.822V113.639H57.0397V139.425H198.92V185H0.94751Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
